export const selectSystemCaches = (state) => state.systemCaches;
export const selectSystemCacheData = (state) => state.systemCacheData;
export const selectDbServices = (state) => state.dbServices;
export const selectDbServiceTables = (state) => state.dbServiceTables;
export const selectJobs = (state) => state.jobs;
